import React, { useEffect, useState } from 'react';
import './Events.css';
import iconBack from '../../assets/images/icon-back.svg';
import { supabase } from '../../lib/supabase';
import NoticeDetail from './NoticeDetail';

interface EventsProps {
  onBack: () => void;
}

interface Event {
  id: string;
  title: string;
  content: string;
  created_at: string;
  notification_type: string;
  image_url?: string;
  end_date?: string;
}

const Events: React.FC<EventsProps> = ({ onBack }) => {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('notification_type', 'promotion')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('이벤트 조회 실패:', error);
        return;
      }

      setEvents(data || []);
    } catch (error) {
      console.error('이벤트 조회 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).replace(/\. /g, '.').replace(/\.$/, '');
  };

  const getEventStatus = (event: Event) => {
    if (!event.end_date) return '진행중';

    const now = new Date();
    const endDate = new Date(event.end_date);
    return now > endDate ? '종료' : '진행중';
  };

  const handleEventClick = (event: Event) => {
    setSelectedEvent(event);
  };

  const handleBackToList = () => {
    setSelectedEvent(null);
  };

  // 상세 화면 표시
  if (selectedEvent) {
    return <NoticeDetail notice={selectedEvent} onBack={handleBackToList} isEvent={true} />;
  }

  return (
    <div className="events-container">
      <div className="events-header">
        <div className="events-header-wrapper">
          <img src={iconBack} alt="뒤로가기" className="header-icon" onClick={onBack} />
          <h1 className="events-title">이벤트/프로모션</h1>
          <div className="header-icon"></div>
        </div>
      </div>

      <div className="events-content">
        <h2 className="events-page-title">이벤트/프로모션</h2>
        {loading ? (
          <div className="events-loading">로딩 중...</div>
        ) : events.length === 0 ? (
          <div className="events-empty">진행 중인 이벤트가 없습니다.</div>
        ) : (
          <div className="events-list">
            {events.map((event) => {
              const status = getEventStatus(event);
              return (
                <div key={event.id} className="event-item" onClick={() => handleEventClick(event)}>
                  <div className="event-info">
                    <h3 className="event-title">{event.title}</h3>
                    <span className="event-date">{formatDate(event.created_at)}</span>
                  </div>
                  <span className={`event-status ${status === '진행중' ? 'ongoing' : 'ended'}`}>
                    {status}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
